import { bonusesClient } from "@/shared/rpc/clients";
import { userStore } from "@/shared/stores/UserStore";
import type { BonusMessage } from "@cronika/proto/common/bonus_pb";
import { makeAutoObservable, runInAction } from "mobx";

class BonusStore {
  fetching = false;
  fetched = false;
  bonus: BonusMessage | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchCurrent() {
    if (this.fetched || this.fetching) return;
    runInAction(() => { this.fetching = true; });
    try {
      const response = await bonusesClient.getCurrentBonus({});
      runInAction(() => {
        this.bonus = response.data ?? null;
        this.fetched = true;
      });
    } catch {
      // silent
    } finally {
      runInAction(() => { this.fetching = false; });
    }
  }

  async cancelActive() {
    const result = await bonusesClient.cancelMyBonus({});
    runInAction(() => {
      this.bonus = null;
      this.fetched = false;
    });
    await Promise.all([this.fetchCurrent(), userStore.refreshBalance()]);
    return result;
  }

  get isActive(): boolean {
    return userStore.currentAccountType === "real" && Number(userStore.balance?.bonusBalance ?? 0) > 0;
  }

  get minTrade(): number | undefined {
    return this.isActive && this.bonus?.rules?.minTrade ? Number(this.bonus.rules.minTrade) : undefined;
  }

  get maxTrade(): number | undefined {
    return this.isActive && this.bonus?.rules?.maxTrade ? Number(this.bonus.rules.maxTrade) : undefined;
  }

  reset() {
    this.bonus = null;
    this.fetched = false;
    this.fetching = false;
  }
}

export const bonusStore = new BonusStore();
